module.exports = __webpack_public_path__ + "static/img/pass_数据接入.05e44a39.png";